import { useDispatch, useSelector } from "react-redux";
import DismissibleNotificationsOptInTile from "../../../presentational/common/DismissibleNotificationsOptInTile";
import {
  dismissNotificationsOptInBanner,
  hideNotificationsOptInBanner,
  optInToNotifications
} from "../../../../state/modules/savedItems/actions";
import {
  getShouldShowNotificationsOptIn,
  getNotificationsOptInSuccess,
  getNotificationsOptInBucket
} from "../../../../state/modules/savedItems/selectors";

const NotificationsOptInTileContainer = () => {
  const dispatch = useDispatch();
  const shouldShowNotificationsOptIn = useSelector(
    getShouldShowNotificationsOptIn
  );
  const isSuccess = useSelector(getNotificationsOptInSuccess);
  const bucket = useSelector(getNotificationsOptInBucket);

  return (
    <DismissibleNotificationsOptInTile
      showNotificationsOptInTile={
        shouldShowNotificationsOptIn && bucket === "tile"
      }
      onDismiss={() =>
        isSuccess
          ? dispatch(hideNotificationsOptInBanner())
          : dispatch(dismissNotificationsOptInBanner())
      }
      onNotifyMe={() => dispatch(optInToNotifications())}
      isSuccess={isSuccess}
    />
  );
};

export default NotificationsOptInTileContainer;
